import React, { useState, useRef } from 'react';
import Circle from './circle';
import { StyledWrapper, BoxImg, Box, StyledWrapperBox } from './style';
import { AvatarEdition } from '../../../core/AvatarEdition';
import { API } from '../../../../constants/api';

const imageTypes = {
  jpg: 'jpg',
  jpeg: 'jpeg',
  png: 'png',
  tiff: 'tiff',
  bmp: 'bmp',
  JPG: 'JPG',
  JPEG: 'JPEG',
  PNG: 'PNG',
  TIFF: 'TIFF',
  BMP: 'BMP'
};

const ChangeImage = props => {
  const imgAt = useRef();
  const inputFile = useRef();
  const box = useRef();
  const [control, setControl] = useState(false);
  const [img, setImg] = useState(
    `${API}images/avatar/${
      props.user.userId
    }/default?update=${new Date().getTime()}`
  );
  const [imgSend, setImgSend] = useState([]);
  const [diametre, setDiametre] = useState(200);
  const [top, setTop] = useState(0);
  const [left, setLeft] = useState(0);
  const [createCropsResponse, setCreateCropsResponse] = useState(null);
  const [extType, setExtType] = useState('jpg');
  const [isFormat, setIsFormat] = useState(true);

  function updateDisplay(event) {
    const ele = box.current;
    setLeft(event.pageX - ele.offsetLeft - diametre / 2);
    setTop(event.pageY - ele.offsetTop - diametre / 2);
  }

  const getImageFormat = nameFile => {
    const regex = /(?:\.([^.]+))?$/;
    return regex.test(nameFile) && regex.exec(nameFile)[1];
  };

  const getPreview = () => {
    const preview = imgAt.current;
    const file = inputFile.current.files[0];
    const reader = new FileReader();
    const { onChangeFormat } = props;

    const format = imageTypes[getImageFormat(file.name)];
    setIsFormat(format);
    reader.onloadend = () => {
      preview.src = reader.result;
    };

    if (format) {
      if (file) {
        reader.readAsDataURL(file);
        setExtType(getImageFormat(file.name));
      } else {
        preview.src = '';
      }
    } else {
      onChangeFormat(format);
    }
  };

  const sendFile = () => {
    const { uploadAvatarImage, createCrops } = props;
    const realTop =
      (imgAt.current.naturalHeight * top) / box.current.offsetHeight;
    const realLeft =
      (imgAt.current.naturalWidth * left) / box.current.offsetWidth;
    const realDiam =
      (imgAt.current.naturalWidth * diametre) / box.current.offsetWidth;
    const formData = new FormData();

    if (imgSend.length > 0) {
      const type = imgSend[0].type.slice(
        imgSend[0].type.indexOf('/') + 1,
        imgSend[0].type.length
      );

      Array.from(imgSend).forEach(image => {
        formData.append('file', image);
      });
      Promise.resolve(
        uploadAvatarImage(formData, imageTypes[extType || type], {
          offsetX: parseInt(realLeft, 0),
          offsetY: parseInt(realTop, 0),
          sizeX: parseInt(realDiam, 0),
          sizeY: parseInt(realDiam, 0)
        })
      )
        .then(() => {
          setCreateCropsResponse(true);
        })
        .catch(() => {
          setCreateCropsResponse(false);
        });
    } else {
      createCrops({
        offsetX: parseInt(realLeft, 0),
        offsetY: parseInt(realTop, 0),
        sizeX: parseInt(realDiam, 0),
        sizeY: parseInt(realDiam, 0)
      })
        .then(() => {
          setCreateCropsResponse(true);
        })
        .catch(() => {
          setCreateCropsResponse(false);
        });
    }
  };

  return (
    <StyledWrapper>
      <AvatarEdition
        dataFormAvatar={props.userAvatarData}
        edit
        changeImg
        avatar={props.user.avatarId}
        getDiametre={setDiametre}
        setImage={sendFile}
        setImageResult={createCropsResponse}
        {...props}
        isFormat={isFormat}
      />
      <div>
        <input
          type="file"
          onChange={e => {
            getPreview();
            if (isFormat && e) {
              setImg(e.currentTarget.value);
              setImgSend(e.target.files);
            }
          }}
          ref={inputFile}
          id="inputFileImg"
          hidden
        />
      </div>
      <StyledWrapperBox>
        <BoxImg
          className="box_img"
          innerRef={box}
          onClick={e => isFormat && updateDisplay(e)}
          onMouseDown={() => setControl(true)}
          onMouseMove={e => control && isFormat && updateDisplay(e)}
          onMouseUp={() => setControl(false)}
        >
          {img && (
            <React.Fragment>
              <img
                className="avatar-image"
                src={img}
                alt="avatar"
                ref={imgAt}
              />
              <Box style={{ position: 'absolute', top: 0 }}>
                <Circle diametre={diametre} top={top} left={left} />
              </Box>
            </React.Fragment>
          )}
          {!img && !isFormat && (
            <p clasName="text-noImg">
              Sube una foto para poder previsualizarla y seleccionar un recorte
            </p>
          )}
        </BoxImg>
      </StyledWrapperBox>
    </StyledWrapper>
  );
};

export default ChangeImage;
